import type { TimelineSegment } from '../api/types'
import { NOBODY } from '../components/oncall/ganttSegments'
import { zonedMidnightToISO } from './timezone'

function localDateString(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

/** Schedule-timezone assignments positioned inside the browser calendar's local days. */
export function computeLayerSegments(
  layer: {
    shift_duration_seconds: number
    rotation_start: string
    participants?: Array<{ user_name: string; order_index: number }>
  },
  windowStart: Date,
  days: number,
  timezone: string,
): TimelineSegment[] {
  const participants = layer.participants ?? []
  if (participants.length === 0) return []

  const shiftMs = (layer.shift_duration_seconds || 86400) * 1000
  const rotationStart = new Date(layer.rotation_start).getTime()
  const sorted = [...participants].sort((a, b) => a.order_index - b.order_index)
  const segments: TimelineSegment[] = []

  for (let i = 0; i < days; i++) {
    const dayStart = new Date(windowStart)
    dayStart.setDate(dayStart.getDate() + i)
    dayStart.setHours(0, 0, 0, 0)
    const dayEnd = new Date(dayStart)
    dayEnd.setHours(23, 59, 59, 999)

    let dayBeginsAt: number
    try {
      dayBeginsAt = new Date(zonedMidnightToISO(localDateString(dayStart), timezone)).getTime()
    } catch (error) {
      if (error instanceof RangeError) continue
      throw error
    }
    const elapsed = dayBeginsAt - rotationStart
    const user = elapsed < 0 ? NOBODY : (sorted[Math.floor(elapsed / shiftMs) % sorted.length]?.user_name ?? NOBODY)

    segments.push({ start: dayStart.toISOString(), end: dayEnd.toISOString(), user_name: user, is_override: false })
  }
  return segments
}
